export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26')
];

export const server_loads = [];

export const dictionary = {
		"/": [6],
		"/(app)/bookings": [7,[2]],
		"/(app)/cashbook": [8,[2,3]],
		"/(app)/cashbook/closings": [9,[2,3]],
		"/(app)/cashbook/registers": [10,[2,3]],
		"/(app)/documents": [11,[2]],
		"/(app)/guest": [12,[2]],
		"/(app)/guest/companies": [13,[2]],
		"/(app)/guest/import": [14,[2]],
		"/(app)/guest/regulars": [15,[2]],
		"/handover": [21],
		"/login": [22,[4]],
		"/login/change-password": [23,[4]],
		"/login/forgot-password": [24,[4]],
		"/login/hotel-select": [25,[4]],
		"/offer/[hotel]/[token]": [26,[5]],
		"/(app)/pricing": [16,[2]],
		"/(app)/services": [17,[2]],
		"/(app)/settings": [18,[2]],
		"/(app)/statistics": [19,[2]],
		"/(app)/templates": [20,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';